import { render } from "./BaladasView.vue?vue&type=template&id=7b79902a"
import script from "./BaladasView.vue?vue&type=script&lang=js"
export * from "./BaladasView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__